import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink, useLocation } from "react-router-dom";
import { Link } from "@/components/ui";
import { API_KEYS_PAGE, CONTACT_PAGE, HOME_PAGE, POSTS_PAGE } from "@/router/paths";
import { cn } from "@/utils/styleHelper";
export default function MainNavigation() {
    const location = useLocation();
    // Check if we're on the API Keys page or main dashboard
    const isApiKeysActive = location.pathname === API_KEYS_PAGE || location.pathname === HOME_PAGE;
    return /*#__PURE__*/ _jsxs("nav", {
        className: "container flex items-center justify-between p-4",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Link, {
                    href: HOME_PAGE,
                    underline: false,
                    children: "Logo"
                })
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "flex items-center gap-4",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(NavLink, {
                            to: POSTS_PAGE,
                            className: ({ isActive, isPending })=>cn({
                                    active: isActive,
                                    pending: isPending
                                }),
                            children: "Posts"
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx("span", {
                            className: cn("font-medium", {
                                "text-gray-900": isApiKeysActive,
                                "text-gray-500": !isApiKeysActive
                            }),
                            children: "API Keys"
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(NavLink, {
                            to: CONTACT_PAGE,
                            className: ({ isActive, isPending })=>cn({
                                    active: isActive,
                                    pending: isPending
                                }),
                            children: "Contact"
                        })
                    })
                ]
            })
        ]
    });
}
